(function($, Drupal) {
  'use strict';

  Drupal.behaviors.set_collapsers = {
    attach: function(context, settings) {
      let $read_more_toggles = $('.js-read-more-toggle', context);

      $read_more_toggles.on('click', function() {
        $(this).parent().toggleClass('expanded');
      });

      $('#js-collapse-toggle').on('click', function() {
        $('.accordion .collapse').collapse('toggle');
      });
    }
  };
})(jQuery, Drupal);
